'use client';

import RingLandingPage from '@/components/RingLandingPage';
import EcommerceStore from '@/components/EcommerceStore';

export default function Home() {
  return (
    <>
      {/* Desktop: show ecommerce store */}
      <div className="hidden lg:block">
        <EcommerceStore />
      </div>

      {/* Mobile: show Ring landing page */}
      <div className="block lg:hidden">
        <RingLandingPage />
      </div>
    </>
  );
}
